<template>
    <div>
        <SaveWindow text="Данные успешно сохранены"/>
        <ContactNoSaveWindow @confirmNext="confirmNext"/>

        <div class="layout">
            <div class="cabinet-page_bg"></div>

            <HeaderAuth/>
            <div class="cabinet-content-block-wrapper">
                <div class="cabinet-content-block">

                    <AdminNavigation/>
                    <div class="cabinet-content">
                        <div class="heading-wrapper">
                            <div class="title" v-html="$ml.with('VueJS').get('profile')"></div>
                        </div>
                        <div class="cabinet-content-inner">


                            <div class="form form-wrap">

                                <section class="form-section-light">
                                    <div class="section-title">Личные данные</div>
                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.surname}">
                                        <label>Фамилия&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="user.surname"
                                                   name="surname"
                                                   ref="surname"
                                                   type="text"
                                                   @input="valErrors.surname = false; isChanged = true"
                                            >
                                            <div v-show="valErrors.surname" class="msg-form msg-error-field">
                                                Заполните обязательное поле
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.nameAndPatronymic}"
                                    >
                                        <label>Имя и Отчество&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="nameAndPatronymic"
                                                   name="nameAndPatronymic"
                                                   ref="nameAndPatronymic"
                                                   type="text"
                                                   @input="valErrors.nameAndPatronymic = false; isChanged = true"
                                            >
                                            <div v-show="valErrors.nameAndPatronymic" class="msg-form msg-error-field">
                                                Заполните обязательное поле
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.email}"
                                    >
                                        <label>Email&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="user.email"
                                                   name="email"
                                                   ref="email"
                                                   type="email"
                                                   v-validate="'required|email'"
                                                   v-on:keydown="registerStatus = registerStatuses.newReg"
                                                   @input="valErrors.email = false; isChanged = true"
                                            >
                                            <div v-show="valErrors.email" class="msg-form msg-error-field">
                                                {{ errors.first('email') }}
                                            </div>
                                            <div v-show="registerStatus === registerStatuses.emailTaken"
                                                 class="msg-form msg-error-field">
                                                Такой email уже зарегистрирован в системе
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section class="form-section-light">
                                    <div class="section-title">Изменить пароль</div>
                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.oldPassword}"
                                    >
                                        <label>
                                            <span>Введите текущий пароль{{'\xa0'}}<span v-if="isPasswordFieldsFilled" class="required">*</span></span>
                                        </label>
                                        <div class="field-input-wrapper">
                                            <input v-model="oldPassword"
                                                   type="password"
                                                   class="field-password"
                                                   @input="valErrors.oldPassword = false; isChanged = true"
                                            >
                                            <div v-show="valErrors.oldPassword" class="msg-form msg-error-field">
                                                {{ valErrors.oldPasswordMessage }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.newPassword}"
                                    >
                                        <label>
                                            <span>Введите новый пароль{{'\xa0'}}<span v-if="isPasswordFieldsFilled" class="required">*</span></span>
                                        </label>
                                        <div class="field-input-wrapper">
                                            <input v-model="newPassword"
                                                   type="password"
                                                   class="field-password field-password_new field-password_new1"
                                                   @input="valErrors.newPassword = false; isChanged = true"
                                            >
                                            <div v-show="valErrors.newPassword" class="msg-form msg-error-field">
                                                {{ valErrors.newPasswordMessage }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.newPasswordConfirm || (newPasswordConfirm !== '' && newPassword !== newPasswordConfirm)}"
                                    >
                                        <label>
                                            <span>Введите новый пароль повторно{{'\xa0'}}<span v-if="isPasswordFieldsFilled" class="required">*</span></span>
                                        </label>
                                        <div class="field-input-wrapper">
                                            <input v-model="newPasswordConfirm"
                                                   type="password"
                                                   class="field-password field-password_new field-password_new2"
                                                   @input="valErrors.newPasswordConfirm = false; isChanged = true"
                                            >
                                            <div v-if="newPasswordConfirm !== '' && newPassword !== newPasswordConfirm" class="msg-form msg-error-field">
                                                Введенные пароли не совпадают
                                            </div>
                                            <div v-show="valErrors.newPasswordConfirm" class="msg-form msg-error-field">
                                                Заполните обязательное поле
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <div class="button-block">
                                    <button class="button button-dark modal-save-email"
                                            :disabled="pressed"
                                            @click="save"
                                    >
                                        Сохранить
                                    </button>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </div>
        <FooterAuth/>
    </div>
</template>


<script>

import FooterAuth from "../../components/FooterAuth";
import HeaderAuth from "../../components/HeaderAuth";
import AdminNavigation from "../../components/AdminNavigation";
import SaveWindow from "@/components/windows/SaveWindow";
import ContactNoSaveWindow from "@/components/windows/ContactNoSaveWindow";
import rest from '../../restUtils';

const registerStatusesInternal = Object.freeze({
    newReg: 1,
    success: 2,
    emailTaken: 3
});


export default {
    name: 'Profile',
    components: {ContactNoSaveWindow, SaveWindow, AdminNavigation, HeaderAuth, FooterAuth},
    metaInfo: {
        title: 'Профиль | Your Last Word'
    },

    beforeCreate() {
        $('body').attr('class', 'cabinet-page');
    },

    data() {
        return {
            user: {
                surname: '',
                name: '',
                patronymic: '',
                email: '',
            },
            nameAndPatronymic: '',
            oldPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
            registerStatuses: registerStatusesInternal,
            registerStatus: registerStatusesInternal.newReg,
            pressed: false,
            valErrors: {
                email: false,
                surname: false,
                nameAndPatronymic: false,
                oldPassword: false,
                newPassword: false,
                newPasswordConfirm: false,
                oldPasswordMessage: '',
                newPasswordMessage: ''
            },
            isChanged: false,
            next: {}
        };
    },

    async created() {
        await this.$store.dispatch('loadCurrentUserData');
        let user = this.$store.getters.currentUser;
        this.user.surname = user.surname;
        this.user.name = user.name;
        this.user.patronymic = user.patronymic === null ? '' : user.patronymic;
        this.user.email = user.email;
        this.nameAndPatronymic = this.user.name + ' ' + this.user.patronymic;
    },

    watch: {
        newPassword() {
            let reg = new RegExp(/^[a-zA-Z0-9]{4,16}$/)
            if (this.newPassword !== '' && !reg.test(this.newPassword)) {
                this.valErrors.newPassword = true;
                this.valErrors.newPasswordMessage = "Пароль должен содержать от 4 до 16 символов. Можно использовать цифры и буквы латинского алфавита в верхнем или нижнем регистре";
            }
        }
    },

    computed: {
        isPasswordFieldsFilled() {
            let isFilled = this.oldPassword !== '' || this.newPassword !== '' || this.newPasswordConfirm !== '';
            if (!isFilled) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.valErrors.oldPassword = false;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.valErrors.newPassword = false;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.valErrors.newPasswordConfirm = false;
            }
            return isFilled;
        }
    },

    methods: {
        async save() {
            if (this.pressed) {
                return;
            }

            this.pressed = true;
            let errors = false;

            if (this.errors.has('email') || this.registerStatus.emailTaken) {
                this.valErrors.email = true;
                errors = true;
            }

            if (this.user.surname.trim() === '') {
                this.valErrors.surname = true;
                errors = true;
            }

            if (this.nameAndPatronymic === '') {
                this.valErrors.nameAndPatronymic = true;
                errors = true;
            }

            if (this.oldPassword !== '' || this.newPassword !== '' || this.newPasswordConfirm !== '') {
                if (this.oldPassword === '') {
                    this.valErrors.oldPassword = true;
                    this.valErrors.oldPasswordMessage = 'Заполните обязательное поле';
                    errors = true;
                }

                if (this.newPassword === '') {
                    this.valErrors.newPassword = true;
                    this.valErrors.newPasswordMessage = 'Заполните обязательное поле';
                    errors = true;
                }

                if (this.newPasswordConfirm === '') {
                    this.valErrors.newPasswordConfirm = true;
                    errors = true;
                }

                if (this.newPasswordConfirm !== this.newPassword) {
                    errors = true;
                }

                let reg = new RegExp("[a-zA-Z0-9]{4,16}");
                if (!reg.test(this.newPassword)) {
                    errors = true;
                }
            }

            if (!errors) {
                let names = this.nameAndPatronymic.split(' ');
                let userReg = {
                    surname: this.user.surname,
                    name: names.length > 1 ? names.slice(0, -1).join(' ') : names[0],
                    patronymic: names.length > 1 ? names.slice(-1).join(' ') : '',
                    email: this.user.email,
                    password: this.oldPassword,
                    newPassword: this.newPassword
                };
                try {
                    let answer = await rest.doPut('/user', userReg);
                    if (answer.errorCode) {
                        this.valErrors.oldPassword = true;
                        this.valErrors.oldPasswordMessage = 'Текущий пароль введен неверно';
                    } else {
                        this.registerStatus = this.registerStatuses.success;
                        if (this.isChanged) {
                            $('.window-wrapper.window-save-contacts').addClass('window-open');
                            $('body').addClass('blocked');
                        }
                        this.isChanged = false;
                        this.oldPassword = '';
                        this.newPassword = '';
                        this.newPasswordConfirm = '';
                        await this.$store.dispatch('loadCurrentUserData');
                    }
                } catch(error) {
                    this.valErrors.email = true;
                    this.registerStatus = this.registerStatuses.emailTaken;
                }
            }

            this.pressed = false;
        },

        confirmNext() {
            this.next();
        }
    },

    beforeRouteLeave (to, from, next) {
        if (this.isChanged) {
            $('.window-wrapper.window-no-save-contacts').addClass('window-open');
            $('body').addClass('blocked');
            this.next = next;
        } else {
            next();
        }
    },
}

</script>

